import { styled } from "styled-components";

export const MyReceiptContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  width: 600px;
`;
